<!--首页-->
<template>
    <div>
    </div>
</template>
<style scoped>
    @import '../../assets/style/index.css';
    .partner-box{display: flex;justify-content: space-between;flex-wrap: wrap;}
    .partner-items{width: 47.5%;height: 1.66rem;display: flex;justify-content: center;align-items: center;
    box-shadow: 0px 0px 10px 2px rgba(0,0,0,0.1); border-radius: 10px;margin-bottom: 10px;}

    .news-latform,.news-read{color:#717071;
        font-size:12px;
        font-weight:400;
        font-family:'PingFangSC-Medium,PingFang SC'}
    .news-title{
        color:#333333;
        font-size:16px;
        font-weight:400;
        font-family:'PingFangSC-Medium,PingFang SC';
        margin-top:10px;
        margin-bottom:5px
    }
    .news-banner{
        width: 100%;
        border-radius: 10px;
        overflow: hidden;
    }
    .news-banner img{width: 100%;}

    .info-itmes2-box{width: 25%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
     .info-item-title{
        font-size:13px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        margin-top:10px
    }
    .train-items{width: 3.08rem; margin-bottom: 0.3rem}
     
    .items-top1{background-image: linear-gradient(to right, #01EA9B , #8DEC9D);}
    .items-top2{background-image: linear-gradient(to right, #2B7AFF , #1EB2FF);}

    .train-items-top{width: 3.08rem;height: 1.68rem;border-radius: 10px;
        display: flex;align-items: center;justify-content: space-around;}
    .train-items-top-city{color:#fff; font-size:32px;font-weight:500; font-family:PingFangSC-Medium,PingFang SC  }
    .train-items-top-time{color:#fff; font-size:15px;font-weight:500; font-family:PingFangSC-Medium,PingFang SC  }
    .train-sing-up-btn{width: 48px;height: 26px;color:#fff;font-size:12px;font-weight:500;font-family:'PingFangSC-Medium,PingFang SC';
        border: 1px solid #fff;border-radius: 26px;text-align: center;line-height: 26px; }
    .train-items-title{color:#333;font-size:14px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC';margin: 5px 0; }
    .train-items-time,.train-items-address{color:#595757;font-size:12px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC'; }
    .train-items-address{margin-right: 10px;}


    .box2-right .time{color:#595757;font-size:12px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC'; }
    .box2-right .address{color:#595757;font-size:12px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC'; }
    .to-active-btn{color:#fff;font-size:14px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC';background: #01EA9B;border-radius: 26px;
    width: 1.4rem;height: 26px;text-align: center;line-height: 26px;letter-spacing:10px;text-indent: 2px;}
    .couduct-active-box2 .box2-right{flex:1;display: flex;flex-direction: column;justify-content: space-between;}
    .couduct-active-box2 .box2-left{width:2.86rem;height:1.41rem;position:relative;border-radius:10px;overflow:hidden;margin-right:20px}
    .sing-up-btn{color:#fff;font-size:14px;font-weight:400;width: 1.4rem;height: 26px;border-radius: 26px;background: #FF433E;
    text-align: center;line-height: 26px; }
    .couduct-address-box{display: flex;justify-content: space-between;}
    .couduct-address{display: flex;align-items: center;}
    .couduct-address .time{color:#595757;font-size:12px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC';margin-left: 25px;}
    .couduct-address .address{color:#595757;font-size:12px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC';margin-left: 10px; }

    .active-couduct-title{    display: flex;align-items: center;margin: 5px 0;}
    .active-title{color: #333;font-size: 16px;font-weight: 400 }
    .hot-sing-up{font-size:20px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:500;
        color:#FF433E;margin-bottom: 5px;}
    .active-couduct1{
        background-color:#FF9535
    }
    .active-couduct2{
        background-color:#01EA9B
    }
    .active-couduct-box{
        color:#fff;
        font-size:12px;
        font-family:'PingFangSC-Medium,PingFang SC';
        position: absolute;
        top: 10px;
        left: 10px;
        height: 20px;
         text-align: center;
        line-height: 20px;
        border-radius: 20px;
        width: 58px;
        
    }
    .more-items{width: 2.02rem;position: relative;display: flex;align-items: center;}
    .more-items img{width: 2.02rem;}
    .more-items span{font-size:14px;
        font-family:'PingFangSC-Regular,PingFang SC';
        font-weight:400;
        color:rgba(255,255,255,1);
         position: absolute;left: 7px;}
    .index-header{display: flex;justify-content: space-between;height: 54px;align-items: center;}
    .index-header-face{width: 54px;height: 54px;display: block;margin:0 16.5px 0 4.5px;}
    .index-search{flex:1;height:30px;border-radius: 5px;background: #fff;display: flex;align-items: center;}
    .index-search-name{ font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(186,186,186,1); }
    .index-search img{width: 14px;height: 14px;display: block;margin: 0 11.5px 0 14.5px;}  
    .index-header-right{width: 25px;height: 18px;margin: 0 8.5px 0 18.5px;}
    .index-header-right img{display: block;width: 100%;}
    .header-top-back{position:absolute;top: 0;z-index: -1;}
    .index-main{width: 100%;margin-top: 17px;overflow: hidden;}
    .main-box{width: 7.1rem;border-radius: 10px 10px 0 0;background: #fff;margin:0 auto;padding: 10px 0;}
    .header {
        line-height: normal;
    }
    .header-left {
        height: 45px;
    }
    .box {
        background: #F8F8F8;
        margin-bottom: 50px;
         
        overflow: hidden;
        background-image: url('../../assets/images/bg-mine-index.png') ;
        background-repeat: no-repeat;
        background-size: 100% ;
    }

    .header {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1;
        background: #fff;
        padding-top: 5px;
        margin: 0!important;
    }

    .header-user-img {
        width: 50px;
        height: 50px;
        margin: -7px 0 0 5px;
    }

    .header-user-text {
        width: 87px;
        text-align: center;
    }

    .header-right-box {
        width: 202.5px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border-radius: 5px;
        padding: 0 15px;
        box-sizing: border-box;
    }

    .search-input {
        display: block;
        height: 30px;
        text-overflow: clip;
        overflow: hidden;
        white-space: nowrap;
        font-family: UICTFontTextStyleBody;
    }

    .goods-type {
        top: 50px;
        position: fixed;
        width: 100%;
        background: #fff;
        z-index: 10;
    }

    input::-webkit-input-placeholder { /* WebKit browsers */
        color: #BABABA;
    }

    input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color: #BABABA;
    }

    input::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #BABABA;
    }

    input:-ms-input-placeholder { /* Internet Explorer 10+ */
        color: #BABABA;
    }
    .more-box{
        width: 6.25rem;
        background: #fff;
        margin:20px auto;
        border-radius: 10px;
        overflow: hidden;
        padding: 20px;
    }
    .more-active{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .solid1{background-image: linear-gradient( #1EB2FF , #2B7AFF);}
    .solid2{background-image: linear-gradient( #FFC934 , #FF9C00);}
    .solid3{background-image: linear-gradient( #FF7D6F , #FF433E);}
    .solid4{background-image: linear-gradient( #E77EFF , #8B5AFD);}
    .solid5{background-image: linear-gradient( #FFC934 , #FF9C00);}
    .solid6{background-image: linear-gradient( #1EB2FF , #2B7AFF);}
    .solid7{background-image: linear-gradient( #FF7D6F , #FF4540);}




    .more-active .solid{width: 4px;height: 25px;border-radius: 4px;margin-right: 5px;}
    .more-active .more-title{color:#333;font-size:16px; height: 25px;line-height: 25px;}
    .more-active .more-right{color:#333;font-size:14px; height: 25px;line-height: 25px;}
    .more-active img{margin-left: 5px;width: 5.5px;height: 10px;}
    .main-solid{width:100%;height:1px;background-color:#f8f8f8;margin:20px 0}
    .flex-between{display:flex;justify-content: space-between;}
    .fontFamily{font-family:'PingFangSC-Regular,PingFang SC';}
</style>

<script>
    import Vue from 'vue';
    import slidePics from '@/components/index/SlidePics.vue';
    import navButton from '@/components/index/navButton.vue';
    import TabBar from '@/components/TabBar.vue';
    import ybb_loading from '@/components/ybb_loading.vue';

     export default {
        name: 'Index',
        components: {
            // TabBar,
            slidePics,
            navButton,
            TabBar,
            ybb_loading
            // goodsList0,
            // goodsList1,
            // goodsList2,
            // goodsList3,
            // GoodsItems,
            // loginDialog,
            // CopyRight,
            // pic,
            // notice
        },
        data: function () {
            return {
                loginShow:false,
                pageId: 1,
                contentList: [],
                pageList: {
                    sai:{
                        doing:[]
                    }
                },
                share: {
                    title: '-',
                    path: '-',
                    imageUrl: '',
                },
                header: {},
                top: '90px',
            }
        },
        filter: {},
        mounted() {
            document.title = '首页';
            this.loadList()
            this.fetch()
        },
        destroyed() {
        },
        methods: {
            loadList() {
                let that = this;
                this.$api.get('/api/index/contentList', {page_id: that.page_Id}, (res) => {
                    // console.log(res)

                    that.contentList = res.data;
                })
            },

            fetch() {
                let that = this;
                this.$api.get('/api/index/indexData', {page_id: that.pageId}, (res) => {
                    // console.log(res);
                    that.pageList = res.data.pageList
                    that.header = res.data.header
                    that.share = res.data.share

                    that.wxShare(res.data.share.title, res.data.share.desc, res.data.share.url, res.data.share.pic_url);

                })
            },

            // 搜索
            onSearch() {
                this.$router.push('/search')
                // console.log('onSearch')
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Index.vue?24a7c852